import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProviderPanel from '../communications/ProviderPanel';
import { loadProviderStatus } from '../../services/CommunicationsService';
import type { ProviderStatus } from '../../types/Communications';
import '../../styles/components/CommunicationsView.css';

/**
 * WhatsApp Business (Gupshup) setup. The keys are stored once per workspace; owners and admins may set them.
 * Communications links here (#whatsapp).
 */
const WorkspaceWhatsAppSection: React.FC = () => {
  const [provider, setProvider] = useState<ProviderStatus | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const { hash } = useLocation();

  const reload = useCallback(async () => {
    try {
      setProvider(await loadProviderStatus());
    } catch {
      // Unknown status: the form still shows; the server checks every save.
    }
  }, []);

  useEffect(() => { void reload(); }, [reload]);

  useEffect(() => {
    if (hash === '#whatsapp') sectionRef.current?.scrollIntoView?.({ block: 'start' });
  }, [hash]);

  return (
    <div id="whatsapp" ref={sectionRef} className="settings-card-spaced">
      <ProviderPanel provider={provider} onChanged={() => void reload()} />
    </div>
  );
};

export default WorkspaceWhatsAppSection;
